<div class="registraion-container">
    <div class="flex-spacer"></div>
    <div class="row">
        <div class="row">
            <img src="{{logoUrl}}" class="logo" />
        </div>
        <div class="row" *ngIf="tenantLogo != ''">
            <img src="{{tenantLogo}}" class="logo" />
        </div>
    </div>
    <div class="row">
        <div *ngIf="!loading && registrationValid">
            <h1>{{ (userExists? '@join' : '@registerUser') | translate }}: {{tenantName}}</h1>
        </div>
        <mat-spinner class="center" *ngIf="loading"></mat-spinner>
        <form [formGroup]="registrationForm" [class.form-loading]="submitting" (keydown.enter)="$event.preventDefault()"
            *ngIf="registrationForm && registrationValid && !userExists && !loading">
            <div>
                <mat-form-field class="padded-input">
                    <mat-label>{{ '@firstName' | translate }}</mat-label>
                    <input matInput class="text-black" formControlName="firstName" type="text">
                </mat-form-field>
                <mat-form-field class="padded-input">
                    <mat-label>{{ '@lastName' | translate }}</mat-label>
                    <input matInput class="text-black" formControlName="lastName" type="text">
                </mat-form-field>
            </div>
            <div class="phone-row">
                <mat-form-field class="padded-input">
                    <mat-label>{{ '@phoneNumber' | translate }}</mat-label>
                    <input matInput class="text-black" formControlName="phoneNumber" type="text"
                        pattern="\d{3}[\-]\d{3}[\-]\d{4}" mask="000-000-0000" [dropSpecialCharacters]="false">
                    <mat-error>{{ '@phoneNumberPatternError' | translate }}</mat-error>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="padded-input">
                    <mat-label>{{ '@password' | translate }}</mat-label>
                    <input matInput class="text-black" formControlName="password" type="password">
                    <mat-error>{{ '@passwordRequirementsError' | translate }}</mat-error>
                </mat-form-field>
                <mat-form-field class="padded-input">
                    <mat-label>{{ '@confirmPassword' | translate }}</mat-label>
                    <input matInput class="text-black" formControlName="confirmPassword" type="password"
                        (keyup)="checkPasswords()">
                    <mat-error>{{ '@passwordMatchError' | translate }}</mat-error>
                </mat-form-field>
            </div>
            <div class="registraion-button-container">
                <div class="flex-spacer"></div>
                <button mat-raised-button color="primary" title="{{'@register' | translate}}"
                    [disabled]="submitting" (click)="submit()">
                    <mat-spinner diameter="20" *ngIf="submitting" class="btn-spinner"></mat-spinner>
                    {{'@register' | translate}}
                </button>
            </div>
        </form>
    </div>
    <div *ngIf="registrationError && !loading" class="row">
        {{registrationError}}
    </div>
    <div *ngIf="userExists && !loading" class="row">
        <button mat-raised-button color="primary" title="{{'@acceptInvite' | translate}}"
            [disabled]="submitting" (click)="submitExisting()">
            <mat-spinner diameter="20" *ngIf="submitting" class="btn-spinner"></mat-spinner>
            {{'@acceptInvite' | translate}}
        </button>
    </div>
    <div class="flex-spacer"></div>
</div>